/* eslint-disable no-unused-vars */
import axios from "axios";

// API endpoints
const API_BASE_URL =
  "https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3";
const POLICIES_ENDPOINT = "/policies";

/**
 * Fetch policies with pagination and optional filtering
 *
 * @param {number} page - Current page number (1-based)
 * @param {number} pageSize - Number of results per page
 * @param {string} searchTerm - Optional search term to filter policies
 * @param {string} policyArea - Optional policy area to filter by
 * @returns {Promise} - Promise containing paginated policy data
 */

// Sample data - this would be replaced with real data from your backend
const samplePolicies = [
  {
    bill_id: "r6930",
    bill_name:
      "Aboriginal Land Grant (Jervis Bay Territory) Amendment Bill 2022",
    date: "2023-08-10",
    url: "http://parlinfo.aph.gov.au/parlInfo/search/display/display.w3p;query=Id:legislation/billhome/r6930",
    KEY_PROVISIONS: [
      "Strengthening land rights for Aboriginal people",
      "Improving governance structures for land management",
    ],
    MAIN_PURPOSE:
      "Amend legislation to strengthen land rights and governance for Aboriginal people in Jervis Bay Territory.",
    POLICY_AREA: "Social Services",
    POLICY_SUBAREA: "Indigenous Affairs",
    POLICY_STATEMENT:
      "Strengthen Aboriginal land rights in Jervis Bay Territory.",
    POLITICAL_SPECTRUM: "Progressive/left-leaning",
    parties: {
      Labor: {
        stance: "Support",
        argument:
          "Addresses historical injustices and empowers Aboriginal communities.",
        votes_for: 78,
        votes_against: 0,
      },
      Liberal: {
        stance: "Mixed",
        argument:
          "Concerns about implementation details and impacts on existing systems.",
        votes_for: 32,
        votes_against: 27,
      },
      Greens: {
        stance: "Strong Support",
        argument:
          "Step forward in Indigenous self-determination, though it could go further.",
        votes_for: 12,
        votes_against: 0,
      },
      Nationals: {
        stance: "Oppose",
        argument:
          "Concerns about implications for regional communities and land users.",
        votes_for: 0,
        votes_against: 14,
      },
      Independents: {
        stance: "Varied",
        argument:
          "Positions vary by representative, with most supporting principles.",
        votes_for: 9,
        votes_against: 3,
      },
    },
  },
  {
    bill_id: "r7245",
    bill_name: "Renewable Energy Target Legislation Amendment Bill 2023",
    date: "2023-11-15",
    url: "http://parlinfo.aph.gov.au/example",
    KEY_PROVISIONS: [
      "Increase renewable energy target to 82% by 2030",
      "Create incentives for renewable energy projects",
    ],
    MAIN_PURPOSE:
      "Accelerate Australia's transition to renewable energy sources and reduce carbon emissions.",
    POLICY_AREA: "Environment",
    POLICY_SUBAREA: "Climate Change",
    POLICY_STATEMENT:
      "Set ambitious renewable energy targets to address climate change.",
    POLITICAL_SPECTRUM: "Progressive/left-leaning",
    parties: {
      Labor: {
        stance: "Support",
        argument:
          "Essential for meeting climate commitments and creating clean energy jobs.",
        votes_for: 75,
        votes_against: 0,
      },
      Liberal: {
        stance: "Oppose",
        argument:
          "Too ambitious, risks energy reliability and higher costs for consumers.",
        votes_for: 4,
        votes_against: 54,
      },
      Greens: {
        stance: "Mixed",
        argument:
          "Supports higher targets but believes the bill doesn't go far enough.",
        votes_for: 8,
        votes_against: 4,
      },
      Nationals: {
        stance: "Strong Oppose",
        argument:
          "Harms regional communities dependent on traditional energy industries.",
        votes_for: 0,
        votes_against: 14,
      },
      Independents: {
        stance: "Support",
        argument:
          "Necessary step toward addressing climate crisis and future-proofing economy.",
        votes_for: 12,
        votes_against: 2,
      },
    },
  },
  {
    bill_id: "r6812",
    bill_name: "Cost of Living Relief Package Bill 2023",
    date: "2023-06-22",
    url: "http://parlinfo.aph.gov.au/example",
    KEY_PROVISIONS: [
      "Energy bill rebates for eligible households",
      "Temporary fuel excise reduction",
      "Rent assistance increase",
    ],
    MAIN_PURPOSE:
      "Provide immediate financial relief to Australians struggling with rising living costs.",
    POLICY_AREA: "Economy",
    POLICY_SUBAREA: "Cost of Living",
    POLICY_STATEMENT:
      "Deliver targeted relief to help Australians with cost of living pressures.",
    POLITICAL_SPECTRUM: "Centrist",
    parties: {
      Labor: {
        stance: "Strong Support",
        argument:
          "Essential support for families facing economic pressure from inflation and rate rises.",
        votes_for: 78,
        votes_against: 0,
      },
      Liberal: {
        stance: "Support",
        argument:
          "Necessary relief, though concerned about long-term fiscal implications.",
        votes_for: 52,
        votes_against: 6,
      },
      Greens: {
        stance: "Mixed",
        argument:
          "Supports intent but believes measures don't go far enough for most vulnerable.",
        votes_for: 7,
        votes_against: 5,
      },
      Nationals: {
        stance: "Support",
        argument:
          "Important support for regional communities facing economic challenges.",
        votes_for: 12,
        votes_against: 2,
      },
      Independents: {
        stance: "Support",
        argument:
          "Provides needed relief while economy adjusts to inflationary pressures.",
        votes_for: 12,
        votes_against: 0,
      },
    },
  },
];
export const fetchPolicies = async (
  page = 1,
  pageSize = 10,
  searchTerm = "",
  policyArea = ""
) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      pageSize,
      ...(searchTerm && { searchTerm }),
      ...(policyArea && { policyArea }),
    });

    // Make the API call
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}?${params}`
    );

    // // Return the data
    return response.data;
    // return {policies: samplePolicies}
  } catch (error) {
    console.error("Error fetching policies:", error);
    throw error;
  }
};

/**
 * Fetch a single policy by ID
 *
 * @param {string} policyId - The ID of the policy to fetch
 * @returns {Promise} - Promise containing the policy data
 */
export const fetchPolicyById = async (policyId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}/${policyId}`
    );
    return response.data;
    // return samplePolicies
  } catch (error) {
    console.error(`Error fetching policy ${policyId}:`, error);
    throw error;
  }
};


export const fetchMpsById = async (divisionID) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}?divisionID=${divisionID}`
    );
    return response.data;
    // return samplePolicies
  } catch (error) {
    console.error(`Error fetching mps ${divisionID}:`, error);
    throw error;
  }
};



export const fetchMpVotesById = async (mpId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}?mpID=${mpId}`
    );
    return response.data;
    // return samplePolicies
  } catch (error) {
    console.error(`Error fetching mps ${mpId}:`, error);
    throw error;
  }
};
/**
 * Fetch all available policy areas
 *
 * @returns {Promise} - Promise containing array of policy areas
 */
export const fetchPolicyAreas = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}/areas`
    );
    return response.data;
    // return ['Economy']
  } catch (error) {
    console.error("Error fetching policy areas:", error);
    throw error;
  }
};

export const fetchMPProfile= async (mpId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}${POLICIES_ENDPOINT}?mpPID=${mpId}`
    );
    return response.data;
    // return ['Economy']
  } catch (error) {
    console.error("Error fetching mp profile:", error);
    throw error;
  }
};